import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { SiteProvider } from "@/context/SiteContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactDialog from "@/components/ContactDialog";
import CookieBanner from "@/components/CookieBanner";
import CustomCursor from "@/components/CustomCursor";
import AppRoutes from "@/AppRoutes";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <SiteProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="App min-h-screen bg-[#080808] text-[#F5F3EE]">
          <Navbar />
          <AppRoutes />
          <Footer />
          <CustomCursor />
          <ContactDialog />
          <CookieBanner />
          <Toaster theme="dark" position="bottom-right" />
        </div>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
